import { useTranslation } from 'react-i18next';

const CARD_CLASS = 'bg-white border border-[#e5e7eb] rounded-xl p-6 h-[390px] flex flex-col';

// dot color, label i18n key
const GROUPS = [
  {
    titleKey: 'subscriptions.admin.overview.subscriberCount.group.growthRetention',
    items: [
      { key: 'active', dot: 'bg-[#22c55e]', textCls: 'text-[#16a34a]' },
    ]
  },
  {
    titleKey: 'subscriptions.admin.overview.subscriberCount.group.conversionPipeline',
    items: [
       { key: 'processing', dot: 'bg-[#60a5fa]', textCls: 'text-[#2563eb]' } ,
       { key: 'retrying', dot: 'bg-[#3949AB]', textCls: 'text-[#3949AB]' } 
    ]
  },
  {
    titleKey: 'subscriptions.admin.overview.subscriberCount.group.churnRiskExposure',
    items: [
      { key: 'cancelled',  dot: 'bg-[#FFC107]', textCls: 'text-[#FF6F00]' },
      { key: 'failed',     dot: 'bg-[#ef4444]', textCls: 'text-[#dc2626]' },
      { key: 'suspended',  dot: 'bg-[#f97316]', textCls: 'text-[#ea580c]' }

    ]
  } 
];

const ALL_KEYS = GROUPS.flatMap((g) => g.items.map((i) => i.key));

const SubscriberCountKPI = ({ data }) => {
  const { t } = useTranslation();

  const isEmpty = !data || ALL_KEYS.every((k) => !data[k]);
  const total = ALL_KEYS.reduce((sum, k) => sum + (data?.[k] ?? 0), 0);

  const label = (key) =>
    t(`subscriptions.admin.overview.subscriberCount.${key}`, {
      defaultValue: key.charAt(0).toUpperCase() + key.slice(1)
    });

  return (
    <div className={CARD_CLASS}>
      {/* Header */}
      <div className="flex items-center justify-between mb-4 shrink-0">
        <p className="text-[15px] font-semibold text-[#353E4A]">
          {t('subscriptions.admin.overview.subscriberCount.title')}
        </p>
      
      </div>

      {isEmpty ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="w-12 h-12 rounded-xl bg-[#F0F2F4] flex items-center justify-center mb-4">
            <svg className="w-5 h-5 text-[#B5BDCA]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-5.196-3.796M9 20H4v-2a4 4 0 015.196-3.796M15 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </div>
          <p className="text-[13px] text-[#97A3B5]">
            {t('subscriptions.admin.overview.subscriberCount.empty')}
          </p>
        </div>
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto pr-1 space-y-3">
          {GROUPS.map((group) => {
            const visibleItems = group.items.filter((item) => (data?.[item.key] ?? 0) > 0 || true);
            return (
              <div key={group.titleKey}>
                <p className="text-[10px] font-semibold uppercase tracking-widest text-[#B5BDCA] mb-1.5 px-0.5">
                  {t(group.titleKey, { defaultValue: group.titleKey.split('.').pop() })}
                </p>
                <div className="rounded-lg border border-[#e6edf5] divide-y divide-[#f1f5f9]">
                  {visibleItems.map(({ key, mergeKeys, dot, textCls }) => {
                    const value = (data?.[key] ?? 0) + (mergeKeys ?? []).reduce((s, k) => s + (data?.[k] ?? 0), 0);
                    return (
                      <div key={key} className="flex items-center justify-between px-3 py-2">
                        <div className="flex items-center gap-2">
                          <span className={`w-2 h-2 rounded-full shrink-0 ${dot}`} />
                          <span className="text-[12px] text-[#64748B]">{label(key)}</span>
                        </div>
                        <span className={`text-[13px] font-semibold tabular-nums ${textCls}`}>
                          {value}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SubscriberCountKPI;
